const requests = {
  fetchNowPlaying: "movie/now_playing",
  fetchTrending: "/trending/all/week",
  fetchTopRated: "/movie/top_rated",
  fetchActionMovies: "/discover/movie?with_genres=28", 
  fetchComedyMovies: "/discover/movie?with_genres=35",
  fetchHorrorMovies: "/discover/movie?with_genres=27",
  fetchRomanceMovies: "/discover/movie?with_genres=10749",
  fetchDocumentaryMovies: "/discover/movie?with_genres=99",
  fetchSciFiMovies: "/discover/movie?with_genres=878",
}

export default requests;